<template>
  <div :class="shareIconsClasses">
    <component
      v-for="(icon, index) in icons"
      :is="getIconComponent(icon)"
      :key="icon.icon"
      :icon="icon.icon"
      :to="icon.url"
      :title="icon.info"
      :title-width="90"
      :is-button="icon.isButton"
      :width="iconWidth"
      :height="iconHeight"
      :color="iconColor"
      :disabled="icon.disabled"
      :open-in-new-tab="openInNewTab || icon.openInNewTab"
      :comment-count="icon.commentCount"
      :original="icon.original"
      :action-icon="ACTION_ICON.IL_COMMENT_COUNT"
      :aria-label="icon.ariaLabel"
      :style="calculateIconStyle(index)"
      class="share-icon"
      @click="onIconClick(icon)"
    />
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AIcon, { ICON, ICON_COLOR, ICON_COLOR_VALUES } from 'shared/AIcon'
import AActionIcon, { ACTION_ICON } from 'shared/AActionIcon'

export const LAYOUT = {
  VERTICAL: 'Vertical',
  HORIZONTAL: 'Horizontal'
}

export default {
  name: 'AIconList',
  components: { AIcon, AActionIcon },
  props: {
    icons: propValidator([PROP_TYPES.ARRAY]),
    iconWidth: propValidator([PROP_TYPES.NUMBER], false, 35),
    iconHeight: propValidator([PROP_TYPES.NUMBER], false, 35),
    verticalSpacing: propValidator([PROP_TYPES.NUMBER], false, 25),
    maxIconCount: propValidator([PROP_TYPES.NUMBER], false, 5),
    iconColor: propValidator(
      [PROP_TYPES.STRING],
      false,
      ICON_COLOR.BLACK,
      prop => ICON_COLOR_VALUES.includes(prop)
    ),
    layout: propValidator([PROP_TYPES.STRING], false, LAYOUT.HORIZONTAL, prop =>
      Object.values(LAYOUT).includes(prop)
    ),
    autocalculatedMargins: propValidator([PROP_TYPES.BOOLEAN], false, true),
    openInNewTab: propValidator([PROP_TYPES.BOOLEAN], false, false),
    descriptionAbsolutePosition: propValidator(
      [PROP_TYPES.BOOLEAN],
      false,
      false
    )
  },
  data() {
    return { ACTION_ICON }
  },
  computed: {
    isVerticalLayout() {
      return this.layout === LAYOUT.VERTICAL
    },
    shareIconsClasses() {
      return ['icons-list', { 'icons-list--vertical': this.isVerticalLayout }]
    }
  },
  methods: {
    getIconComponent({ icon }) {
      return icon === ICON.COMMENT_COUNT_ROUND_BLACK
        ? 'a-action-icon'
        : 'a-icon'
    },
    calculateIconStyle(index) {
      if (!this.autocalculatedMargins) return {}

      const style = {}
      const isLastIcon = index + 1 === this.icons.length
      if (isLastIcon) return style

      if (this.isVerticalLayout) {
        style['margin-bottom'] = `${this.verticalSpacing}px`
      } else {
        const iconsWidth = this.iconWidth * this.maxIconCount
        const spaceCount = this.maxIconCount - 1
        style['margin-right'] = `calc((100% - ${iconsWidth}px)/${spaceCount})`
      }
      return style
    },
    onIconClick({ isButton, mailto }) {
      if (!isButton) return

      this.$helper.mailto(mailto)
    }
  }
}
</script>

<style lang="scss" scoped>
.icons-list {
  display: flex;
  justify-content: center;
  width: 100%;

  &--vertical {
    flex-direction: column;
  }

  .share-icon {
    background: $c--white;
    border-radius: 50%;
  }
}
</style>
